// libs
import Tile from '@/widgets/Tile/';
import React, { useEffect } from 'react';
// stores
import useWriteCampaignStore from '@/stores/WriteCampaign';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import DlsTextField from '@/widgets/DlsTextFeild/DlsTextField';
import { RightActionTypes, TextFieldTypes, } from '@swiggy-private/dls-web-core/dist/components/TextField/types';
// helpers
import { getCloudinaryUrl } from '@/helpers/cloudinary';
import { CampaignWriteModeEnum } from '@/stores/WriteCampaign/constants';
// constants
import { CampaignPlacementsInfo, PlacementEntityEnum, } from '@/constants/placements';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// styles
import style from './AdPlacement.module.scss';
const imageId = 'InstamartAssets/B2B%20Assets/Ads%20Platform/Ad_Placement.png';
const AdPlacement = ({ mode }) => {
    const { name, setName, validationMessages, setPlacementIds, setAdGroupUnitType, isValid, } = useWriteCampaignStore((store) => ({
        name: store.name,
        setName: store.setName,
        validationMessages: store.validationMessages,
        setPlacementIds: store.setPlacementIds,
        setAdGroupUnitType: store.setAdGroupUnitType,
        isValid: store.isValid,
    }));
    useEffect(() => {
        updatePlacementIds();
    }, []);
    const updatePlacementIds = () => {
        if (mode === CampaignWriteModeEnum.CREATE) {
            const { placementId, adUnitType } = CampaignPlacementsInfo[PlacementEntityEnum.PRODUCT][0];
            setPlacementIds([placementId]);
            setAdGroupUnitType(adUnitType);
        }
    };
    const onChange = (value) => {
        setName(value);
        isValid(['name']);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Tile, { className: style.tile },
            React.createElement("div", { className: style.container },
                React.createElement("div", { className: style.content },
                    React.createElement("div", { className: style.description },
                        React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Welcome to Keyword ads"),
                        React.createElement(Text, { className: style.descriptionText, variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis }, "Keyword Based ads show up when user enters a particular search term and the search term matches with the keyword added for your campaign.")),
                    React.createElement("div", { className: style.inputContainer },
                        React.createElement("div", { className: style.inputContainerTitle },
                            React.createElement(Text, { variant: DlsFontVariants.header_H5_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Name your Campaign")),
                        React.createElement(DlsTextField, { textFieldDetails: {
                                value: name,
                                type: TextFieldTypes.TEXT,
                                name: 'campaign-name-input',
                                label: 'Enter Campaign Name' || 'Search',
                                onChange: onChange,
                                attrs: { autoComplete: 'off' },
                                containerStyle: {
                                    marginTop: '12px',
                                },
                                errorText: validationMessages.name,
                            }, rightActionDetails: [
                                {
                                    type: RightActionTypes.CLEAR,
                                },
                            ] }))),
                React.createElement("div", { className: style.imageContainer },
                    React.createElement("img", { src: getCloudinaryUrl(imageId, {
                            width: 372 * 2,
                            height: 400 * 2,
                        }), className: style.image }))))));
};
export default AdPlacement;
